import { FC, MouseEventHandler } from 'react';
import { Button, ButtonProps } from './Button';

interface LinkProps extends Exclude<ButtonProps, 'as'> {}

const preventDefault: MouseEventHandler = (e) => e.preventDefault();

export const Link: FC<LinkProps> = (props) => (
  <Button as="a" {...(props.disabled && { onClick: preventDefault })} {...props} />
);
